export default __webpack_public_path__ + "static/media/Breast_Banner.f27b92ea.jpg";